import { Image } from "antd";
import { API_URL } from "../config";
import { useAuth } from "../providers";
import { useState } from "react";

function ImageUploader({ initialValue, onSaved, style }) {
  const { token } = useAuth();
  const [uploadStatus, setUploadStatus] = useState("");

  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const formData = new FormData();
    formData.append("file", file);

    setUploadStatus("Subiendo imagen...");

    try {
      const maxFileSize = 8 * 1024 * 1024; // 10 MB

      if (file.size > maxFileSize) {
        setUploadStatus("❌ El archivo es demasiado grande (máx. 8MB)");
        return;
      }
      if (!token) {
        setUploadStatus("❌ No hay token de autenticación");
        console.error("No token found");
        return;
      }

      const response = await fetch(`${API_URL}/images/upload`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
        },
        body: formData,
      });

      if (response.ok) {
        const data = await response.json();
        setUploadStatus(`✅ Imagen subida con éxito`);
        console.log(data.url);
        onSaved(data.url);

        if (response.status === 401) {
          setUploadStatus(
            `❌ Sesión expirada, por favor inicia sesión de nuevo`
          );
          console.error("Unauthorized, token might be invalid or expired");
          return;
        }
      } else {
        const errorText = await response.text();
        setUploadStatus(`❌ Error al subir la imagen`);
        console.error(errorText);
      }
    } catch (error) {
      setUploadStatus(`❌ Error en la conexión`);
      console.error(error);
    }
  };

  return (
    <div
      className="p-4"
      style={{
        width: "100%",
        border: "1px dashed #d9d9d9",
        borderRadius: 8,
        minHeight: "200px",
        ...style,
      }}
    >
      <input type="file" onChange={handleFileChange} />
      {uploadStatus && <p className="mt-2">{uploadStatus}</p>}
      {initialValue && (
        <Image
          src={initialValue}
          alt=""
          style={{
            maxHeight: "200px",
            maxWidth: "200px",
            objectFit: "cover",
            padding: "8px",
          }}
        />
      )}
    </div>
  );
}

export default ImageUploader;
